import { useState } from "react";
import InputMask from "react-input-mask";
import api_publica from "components/utils/api-publica";
import StatusMessage from "components/status-message";
import useApiRequest from "hooks/useApiRequest";
import { StyleMessageBox } from "globalStyles";
import { StyleWrapperInput, Loader } from "globalStyles";
import Modal from "components/modal";
import Button from "components/button";
import {
    StyleContent,
    StyleTitleText,
    StyleParagraphText,
    StyleLuckNumberContainer,
    StyleDataBestDrive,
    StyleDescriptionBestDrive,
    StyleInfoBestDrive,
    StyleNumeros,
    StyleNumeroItem,
} from "components/modal-auth/style";

export default ({isModalOpen, setIsModalOpen}) => {
    const { status, handleRequest } = useApiRequest();
    const [formData, setFormData] = useState({
        documento: "",
    });
    const [error, setError] = useState(false);
    const [profissional, setProfissional] = useState({});
    const handleFormDataInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    // 1: Identificação, 2: Numeros da sorte
    const [step, setStep] = useState(1);

    const handleSubmitFormDataSuccess = (response) => {
            if (response.data.length > 0) {
                setProfissional(response.data[0]);
                setStep(2);
            } else {
                setError(true);
            }
        };

        const handleSubmitFormData = async (evt) => {
            evt.preventDefault();
            setError(false);
            handleRequest(
                () => api_publica.get(`/profissionais-campanha?Cpf=${formData.documento}`),
                handleSubmitFormDataSuccess,
                null
            );
        };

        const handleMaskDocument = (v) => {
            return "999.999.999-999";
        };

    return (
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <StyleContent openedStep={step === 1}>
                <form onSubmit={handleSubmitFormData} autoComplete="off">
                    <StyleTitleText>
                        <strong>Identifique-se</strong>
                    </StyleTitleText>
                    <StyleParagraphText>
                        Para consultar o seu número da sorte, informe seus
                        dados.
                    </StyleParagraphText>
                    <StyleWrapperInput>
                        <label htmlFor="documento">CPF*</label>
                        <InputMask
                            placeholder="Somente números"
                            type="text"
                            id="documento"
                            name="documento"
                            mask={handleMaskDocument(formData.documento)}
                            maskChar={""}
                            value={formData.documento}
                            onChange={(e) => {
                                handleFormDataInputChange(e);
                            }}
                            required
                        />
                    </StyleWrapperInput>
                    <StatusMessage
                        error={status.error}
                        messages={status.messages}
                    />
                    <StyleWrapperInput className="text-center">
                        <Button type="submit" disabled={status.disabled}>
                            {status.disabled ? <Loader /> : "Acessar"}
                        </Button>
                    </StyleWrapperInput>
                    {error && (
                        <StyleMessageBox
                            className={`${
                                error ? "bg-danger" : "bg-success"
                            } text-white text-center`}
                        >
                            O CPF informado não está cadastrado. Para conhecer
                            os critérios de desclassificação, consulte o
                            regulamento no{" "}
                            <a
                                href="https://www.vw.com.br/promocao"
                                target="_blank"
                                rel="noreferrer"
                            >
                                www.vw.com.br/promocao{" "}
                            </a>
                        </StyleMessageBox>
                    )}
                </form>
            </StyleContent>
            <StyleContent openedStep={step === 2}>
                <StyleTitleText>
                    <strong>
                        Olá{" "}
                        <span style={{ textTransform: "capitalize" }}>
                            {profissional?.nome?.toLowerCase().split(" ")[0]}{" "}
                            {profissional?.nome
                                ?.toLowerCase()
                                .split(" ")
                                .at(-1)}
                        </span>
                        ,
                    </strong>
                </StyleTitleText>

                <StyleDataBestDrive>
                    <StyleDescriptionBestDrive>
                        Categoria:
                    </StyleDescriptionBestDrive>
                    <StyleInfoBestDrive>
                        {profissional.categoria}
                    </StyleInfoBestDrive>
                </StyleDataBestDrive>

                {profissional?.numerosDaSorte?.length > 0 ? (
                    <StyleLuckNumberContainer>
                        <div>
                            <h2>
                                {profissional.numerosDaSorte.length > 1
                                    ? "Seus números da sorte:"
                                    : "Seu número da sorte:"}
                            </h2>
                            <StyleNumeros>
                                {profissional.numerosDaSorte.map(
                                    (item, index) => (
                                        <StyleNumeroItem key={index}>
                                            {item.numeroDaSorte}
                                        </StyleNumeroItem>
                                    )
                                )}
                            </StyleNumeros>
                        </div>
                    </StyleLuckNumberContainer>
                ) : (
                    <StyleDataBestDrive>
                        <StyleInfoBestDrive>
                            Nenhum número da sorte encontrado para este CPF.
                        </StyleInfoBestDrive>
                    </StyleDataBestDrive>
                )}
            </StyleContent>
        </Modal>
    );
}
